__turbopack_context__.v({
  "Flowmap": "azKVha_Flowmap",
  "InDropdown": "azKVha_InDropdown",
  "Input": "azKVha_Input",
  "Label": "azKVha_Label",
  "Option": "azKVha_Option",
  "Option--Disabled": "azKVha_Option--Disabled",
  "Option--Selected": "azKVha_Option--Selected",
  "RadioMark": "azKVha_RadioMark",
  "Root": "azKVha_Root",
  "Wrapper": "azKVha_Wrapper",
  "skeleton-loading": "azKVha_skeleton-loading",
});
